module.exports = __webpack_public_path__ + "media/images/digivent/coffee-9eb88b5762679f433c861b49c9098fce.jpg";